module.exports = __webpack_public_path__ + "img/gif2.79f0f2c0.gif";